import { motion } from "framer-motion";

interface QuestionSafetyCheckProps {
  onNext: () => void;
  onBack: () => void;
  onSelect: (value: string[]) => void;
  selected: string[];
}

const options = [
  { label: "Couperose (zichtbaar adernet, kleine broken capillaries)", value: "couperose", emoji: "🩸" },
  { label: "Rosacea", value: "rosacea", emoji: "🌹" },
  { label: "Actief eczeem of huidaandoening", value: "eczema", emoji: "🌿" },
  { label: "Zeer reactieve huid (snel rood, branderig of opgezet)", value: "reactive", emoji: "⚠️" },
  { label: "Recente huidbehandeling in de afgelopen 4 weken (peeling, laser, injecties)", value: "recent_treatment", emoji: "💉" },
  { label: "Ik gebruik bloedverdunners of medicatie die invloed heeft op stolling", value: "blood_thinner", emoji: "💊" },
  { label: "Nee, geen van bovenstaande", value: "none", emoji: "✅" },
];

const QuestionSafetyCheck = ({ onNext, onBack, onSelect, selected }: QuestionSafetyCheckProps) => {
  const toggleOption = (value: string) => {
    if (value === "none") {
      onSelect(["none"]);
      return;
    }
    const filtered = selected.filter((s) => s !== "none");
    if (filtered.includes(value)) {
      onSelect(filtered.filter((s) => s !== value));
    } else {
      onSelect([...filtered, value]);
    }
  };

  const hasSelection = selected.length > 0;

  return (
    <div>
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-foreground/80 font-sans text-lg md:text-xl mb-5 md:mb-8 hover:text-foreground transition-colors cursor-pointer px-3 py-2 -ml-3 rounded-lg hover:bg-secondary/50"
      >
        <span className="text-xl">←</span> Terug
      </button>

      <div className="text-center">
        <h2 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-2 leading-tight">
          Voordat we verder gaan, een belangrijke check
        </h2>
        <p className="text-foreground/80 font-sans text-lg mb-6 md:mb-10">
          Voor je veiligheid: heb je last van een van het volgende? Selecteer alles dat van toepassing is.
        </p>

        <div className="grid gap-2 md:gap-3 mb-6 md:mb-8">
          {options.map((opt, i) => (
            <motion.button
              key={opt.value}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * i }}
              onClick={() => toggleOption(opt.value)}
              className={`quiz-option text-left flex items-center gap-4 ${
                selected.includes(opt.value) ? "quiz-option-selected" : ""
              }`}
            >
              <span className="text-2xl flex-shrink-0 w-8 text-center">{opt.emoji}</span>
              <span className="text-foreground font-medium text-lg">{opt.label}</span>
              {selected.includes(opt.value) && (
                <motion.span
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="inline-block ml-2 text-primary"
                >
                  ✓
                </motion.span>
              )}
            </motion.button>
          ))}
        </div>

        {hasSelection && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <button onClick={onNext} className="btn-cta">
              Volgende
            </button>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default QuestionSafetyCheck;
